(async () => {
 const log = (msg, color="#111", bg="#ffc107") =>
   console.log(`%c${msg}`, `font-weight:700; font-size:14px; color:${color}; background:${bg}; padding:4px 8px; border-radius:4px;`);


 const pathMatch = window.location.pathname.match(/\/products\/([^/]+)/);
 const handle = pathMatch ? pathMatch[1] : null;
 const params = new URLSearchParams(window.location.search);
 const searchId = params.get("search_id");
 if (searchId) {
     try {
         await fetch("/cart/update.js", {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({ attributes: { search_id: searchId } })
         });
         console.log("🧾 search_id attached to cart:", searchId);
     } catch (e) {
         console.warn("⚠️ Failed to update cart with search_id", e);
     }
     }
 const userQuery = params.get("query");


 if (!handle) return;
 log(`🧩 Checking localStorage for summary of ${handle}`);


 let cache = null;
 try {
   cache = localStorage.getItem(`ai_summary_cache_${handle}`);
 } catch (err) {
   log("⚠️ localStorage not accessible (sandboxed)", "#fff", "#dc3545");
 }


 if (!cache) {
   log("❌ No cached summary found — nothing to inject", "#fff", "#dc3545");
   return;
 }


 const { summary, ts } = JSON.parse(cache);
 const ageSec = Math.round((Date.now() - ts) / 1000);
 log(`✅ Found cached summary (age: ${ageSec}s)`, "#fff", "#28a745");


 const descWrapper = document.querySelector(".new_product_short_desc");
 if (!descWrapper) {
   log("⚠️ .new_product_short_desc not found in DOM", "#fff", "#dc3545");
   return;
 }


 // 💣 Clear existing content
 descWrapper.innerHTML = "";


 // 🧠 Insert new HTML summary
 const aiSummary = document.createElement("div");
 aiSummary.style.marginTop = "12px";
 aiSummary.style.color = "#444";
 aiSummary.style.opacity = "0";
 aiSummary.style.transition = "opacity 0.6s ease";
 aiSummary.innerHTML = summary; // Gemini's HTML (<h3> + <ul>)
 descWrapper.appendChild(aiSummary);


 // 🎨 Style adjustments — heading color + spacing
 const heading = aiSummary.querySelector("h3");
 if (heading) {
   heading.style.color = "#333";      // dark gray instead of pure black
   heading.style.marginBottom = "8px"; // spacing below heading
 }


 requestAnimationFrame(() => (aiSummary.style.opacity = "1"));
 log("🪄 Replaced .new_product_short_desc content with styled AI summary", "#fff", "#20c997");


 // 🧹 Optional: clear cache
 try { localStorage.removeItem(`ai_summary_cache_${handle}`); } catch {}
 const targetSelector = window.innerWidth <= 768 ? '.product__image-thumbnail' : '.product-form__buttons';
 const target = document.querySelector(targetSelector);
 if(!target) return;


 target.insertAdjacentElement('afterend', descWrapper);
})();